import {
  RAIL_SET_SORT,
  SELECT_RAIL,
  SET_RAIL_RESULTS,
  RAIL_FILTER_BRAND,
  RAIL_APPLIED_FILTERS,
  RAIL_APPLIED_TIME_MATRIX_FILTER,
} from '../actions/rail';

const initialState = { components: {} };

export default (state = initialState, action) => {
  switch (action.type) {
    case RAIL_SET_SORT:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            railSort: {
              sort: action.sort,
              asc: action.asc,
            },
          },
        },
      };

    case SET_RAIL_RESULTS:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            searchResults: action.searchResults,
            brandList: action.brandList,
            filterByDetails: action.filterByDetails,
            railSort: { sort: 'amountToDisplay', asc: true },
            railBrandFilter: action.brandList ? action.brandList[0].brand : '',
            railTimeMatrixFilterBy: action.railTimeMatrixFilterBy,
            filterTimeMatrixList: action.filterTimeMatrixList,
          },
        },
      };

    case SELECT_RAIL:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            selectedRail: action.selectedRail,
            selectedClassFare: action.classFare,
          },
        },
      };
    case RAIL_FILTER_BRAND:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            railBrandFilter: action.key,
          },
        },
      };
    case RAIL_APPLIED_FILTERS:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            filterByDetails: action.filterByDetails,
          },
        },
      };
    case RAIL_APPLIED_TIME_MATRIX_FILTER:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            railTimeMatrixFilterBy: action.selectedTimeMatrix,
          },
        },
      };
    default:
      return state;
  }
};
